import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Auth/Login';
import MainDashboard from './components/MainDashboard';

function App() {
  const [token, setToken] = useState(null); // Initialize as null to force login on first load

  useEffect(() => {
    const handleStorage = () => {
      setToken(localStorage.getItem('token')); // Update token if storage changes
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            !token ? (
              <Login onLogin={t => {
                setToken(t);
                localStorage.setItem('token', t);
              }} />
            ) : (
              <Navigate to="/dashboard" replace />
            )
          }
        />
        <Route
          path="/dashboard"
          element={
            token ? <MainDashboard /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/"
          element={<Navigate to="/login" replace />} // Always redirect to login by default
        />
      </Routes>
    </Router>
  );
}

export default App;